import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import styles from './Purchase.module.css';
import globalStyles from '../../global.module.css';

import classNames from 'classnames/bind';
import Seats from '../Seats/Seats';
import AirlineLogo from '../AirlineLogo/AirlineLogo';

const  cx = classNames.bind(styles);

class Purchase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLongHaul: false,
      isLoadingSeats: false,
      outboundSeat: this.props.isLongHaul ? '10C' : '1A',
      returnSeat: this.props.isLongHaul ? '12B' : '2A',
    };
    this.onCloseSeating = this.onCloseSeating.bind(this);
    this.onSelectSeat = this.onSelectSeat.bind(this);
    this.getSeatContainerStyle = this.getSeatContainerStyle.bind(this);
  }

  onCloseSeating() {
    setTimeout(() => {
      this.setState({
        isLoadingSeats: false,
      });
    }, 750);
  }

  onSelectSeat(direction, seat) {
    let property = (direction === 'outbound') ? 'outboundSeat' : 'returnSeat';

    // ... prepend flight class
    this.setState({
      [property]: seat
    });
  }

  getSeatContainerStyle(direction) {
    return cx({
      seatContainer: true,
      hide: this.state.isLoadingSeats && this.state.isLoadingSeats !== direction
    });
  }

  render() {
    const { isLongHaul } = this.props;
    const flightStyles = cx({
      flight: true,
      isLongHaul: isLongHaul,
      purchaseSection: true,
    });
    const airlineLogoStyle = {
      width: '115px',
      padding: '10px 0 10px',
    };
    
    return (
      <div className={[styles.purchasePageWrapper, (this.state.isLoadingSeats != '' ? styles.takeOff: '')].join(' ')}>
        <div className={styles.planeMaskWrapper} >
          <div className={styles.planeMask} />
          <div className={styles.planeMaskGradient} />
        </div>
        <div className={[styles.header, styles.purchaseSection].join(' ')}>
          <small>REVIEW AND PURCHASE</small>
          { isLongHaul ? <h2>Your trip to<br /> Sydney</h2> : <h2>Your trip to<br /> Santa Barbara</h2> }
        </div>

        <div className={[flightStyles, styles.outbound, (this.state.isLoadingSeats === 'outbound' ? styles.takeOff: '')].join(' ')}>
          <small>Outbound</small>
          { isLongHaul ? <h3>San Francisco →<br /> Sydney</h3> : <h3>San Francisco →<br /> Santa Barbara</h3> }
          <AirlineLogo airline={isLongHaul ? 'virgin' : 'surfair'} style={airlineLogoStyle} dark />
          <ul className={globalStyles.details}>
            <li>Friday, July 14</li>
            <li>7:15am  -  8:25am</li>
            <li>1h 10min</li>
            <li>{ isLongHaul ? `Economy ${this.state.outboundSeat}` : this.state.outboundSeat }</li>
          </ul>
          <div className={styles.changeButton} onClick={() => this.setState({isLoadingSeats: 'outbound'})}>Change Seats</div>
        </div>

        <div className={this.getSeatContainerStyle('outbound')} >
          <Seats
            flight={0}
            planeId={'plane1'}
            direction={'outbound'}
            onClose={this.onCloseSeating}
            onChange={this.onSelectSeat }
            selected={ this.state.outboundSeat }
            zoomed={this.state.isLoadingSeats === 'outbound'}
          />
        </div>

        <div className={[flightStyles, styles.return, (this.state.isLoadingSeats === 'return' ? styles.takeOff: '')].join(' ')}>
          <small>
            Return
          </small>
          { isLongHaul ? <h3>Sydney →<br /> San Francisco</h3> : <h3>Santa Barbara → <br />San Francisco</h3> }
          <AirlineLogo airline={isLongHaul ? 'united' : 'jetsuite'} style={airlineLogoStyle} dark />
          <ul className={globalStyles.details}>
            <li>Saturday, July 15</li>
            <li>2:00pm  -  3:10pm</li>
            <li>1h 10min</li>
            <li>{ isLongHaul ? `Economy ${this.state.returnSeat}` : this.state.returnSeat }</li>
          </ul>
          <div className={styles.changeButton} onClick={() => this.setState({isLoadingSeats: 'return'})}>Change Seats</div>
        </div>

        <div className={this.getSeatContainerStyle('return')} >
          <Seats
            flight={0}
            planeId={'plane1'}
            direction={'return'}
            onClose={this.onCloseSeating}
            onChange={this.onSelectSeat }
            selected={ this.state.returnSeat }
            zoomed={this.state.isLoadingSeats === 'return'}
          />
        </div>

        <div className={[styles.passengers, styles.purchaseSection].join(' ')}>
          { this.state.isLongHaul ?
            <div>
              <h3>Passengers</h3>
              <div className={styles.passenger}>
                <img src={require('./img/user.jpg')} alt="" height="50" width="50" />
                <span>Georgia Smith</span>
              </div>
              <div className={styles.passenger}>
                <img src={require('./img/user-0.png')} alt="" height="50" width="50" />
                <span>Amelia Little</span>
              </div>
            </div>
          :
            <div>
              <h3>Passenger</h3>
              <div className={styles.passenger}>
                <img src={require('./img/user.jpg')} alt="" height="50" width="50" />
                <span>Georgia Smith</span>
              </div>
            </div>
          }
        </div>

        <div className={[styles.payment, styles.purchaseSection].join(' ')}>
          <h3>Payment Details</h3>
          <div className={styles.paymentMethod}>
            <img src={require('./img/amex.png')} alt="" />
            <div>
              <h4>American Express</h4>
              <span>Ending with 9411</span>
            </div>
          </div>
          <div className={styles.emphasizedRow}>
            <div className={styles.col}>(2x) Roundtrip Flight</div>
            <div className={styles.col}>$1,239.00</div>
          </div>
          <div className={styles.row}>
            <div className={styles.col}>U.S. Transportation Tax</div>
            <div className={styles.col}>$11.79</div>
          </div>
          <div className={styles.row}>
            <div className={styles.col}>Sept. 11th Security Fee</div>
            <div className={styles.col}>$5.60</div>
          </div>
          <div className={styles.row}>
            <div className={styles.col}>Passenger Facility Charge</div>
            <div className={styles.col}>$4.50</div>
          </div>
          <div className={styles.row}>
            <div className={styles.col}>Flight Segment Tax</div>
            <div className={styles.col}>$4.10</div>
          </div>
          <div className={styles.row +' '+ styles.total +' '+ (this.state.isLongHaul ? styles.isLongHaul : '')}>
            <div className={styles.col}>Total (USD)</div>
            <div className={styles.col}>$280.00</div>
          </div>
          <div className={styles.footer}>
            { this.props.isLongHaul ?
              <Link className={styles.isLongHaul} to={`/flights/confirmation`}>Purchase 2 Roundtrip Tickets</Link>
            :
              <Link to={`/flights/confirmation`}>Confirm</Link>
            }
          </div>
        </div>

      </div>
    );
  }
}


const mapStateToProps = ({ main }) => ({
  isLongHaul: main.isLongHaul,
  outboundFlightData: main.outboundFlightData,
  returnFlightData: main.returnFlightData,
});

export default connect(mapStateToProps)(Purchase);



// WEBPACK FOOTER //
// ./src/components/Purchase/Purchase.jsx